"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function ANamesGridConsumer() {
  const {
    posts,
    loading,
    error,
    hasNext,
    hasPrev,
    nextPage,
    prevPage
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {[...Array(16)].map((_, i) => <div key={i} data-index={i} className="h-[120px] bg-[#A7F3D0]/10 border border-chart-1/20 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-sm text-destructive">
        Failed to load names. Please try again later.
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="py-12 text-center text-sm text-muted-foreground">
        No names found in this directory.
      </div>;
  }
  return <div className="space-y-12">
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {posts.map((post, i) => <Link key={post.id} to={post.link || "#"} className="group block outline-none" data-index={i}>
            <div className="flex h-full flex-col border border-chart-1 bg-[#A7F3D0]/20 p-6 shadow-none transition-colors duration-300 group-hover:border-[#D8A7CA] group-hover:bg-[#A7F3D0]/30 group-focus-visible:ring-2 group-focus-visible:ring-ring group-focus-visible:ring-offset-2 group-focus-visible:ring-offset-background">
              <h3 className="mb-2 text-[22px] font-semibold leading-tight text-chart-1">
                {post.title}
              </h3>
              <p className="line-clamp-2 text-[14px] text-foreground/80">
                {post.excerpt ? post.excerpt.replace(/(<([^>]+)>)/gi, "") : "Discover the meaning and origin of this beautiful name."}
              </p>
            </div>
          </Link>)}
      </div>

      {(hasNext || hasPrev) && <div className="flex items-center justify-center gap-4 border-t border-border/50 pt-8">
          <Button variant="outline" onClick={prevPage} disabled={!hasPrev} className="rounded-none border-chart-1 text-chart-1 hover:bg-[#A7F3D0]/20 hover:text-chart-1">
            Previous
          </Button>
          <Button variant="outline" onClick={nextPage} disabled={!hasNext} className="rounded-none border-chart-1 text-chart-1 hover:bg-[#A7F3D0]/20 hover:text-chart-1">
            Next
          </Button>
        </div>}
    </div>;
}
export default function ANamesGrid() {
  const wp_query_params = {
    per_page: 24,
    orderby: "title",
    order: "asc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="anames-grid" className="bg-background py-24">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="mb-12 max-w-2xl">
          <h2 className="mb-4 text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            Alphabetical Directory
          </h2>
          <p className="text-lg text-muted-foreground">
            Browse our comprehensive collection of names, organized systematically for easy discovery.
          </p>
        </div>
        
        <PostsProvider wp_query={{
        per_page: 24,
        orderby: "title",
        order: "asc"
      }}>
          <ANamesGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}